<div class="imprint-shell">
<div class="container imprint-page">
    <div class="imprint-intro">
    <span class="imprint-eyebrow">
      {{ 'IMPRINT.LEGAL' | translate }}
    </span>

        <h1>{{ 'MENU.IMPRINT' | translate }}</h1>

        <p class="imprint-description">
            {{ 'IMPRINT.DESCRIPTION' | translate }}
        </p>
    </div>

    <div class="imprint-content">
        <section class="imprint-block">
            <h2>{{ 'IMPRINT.NAME' | translate }}</h2>

            <div class="imprint-text">
                <p>{{ 'IMPRINT.ADDRESS' | translate }}</p>
            </div>

            <div class="imprint-details company-details">
                <div class="imprint-detail">
                    <span class="label">{{ 'IMPRINT.REGISTER_NUMBER_LABEL' | translate }}</span>
                    <p>{{ 'IMPRINT.REGISTER_NUMBER' | translate }}</p>
                </div>

                <div class="imprint-detail">
                    <span class="label">{{ 'IMPRINT.REGISTER_COURT_LABEL' | translate }}</span>
                    <p>{{ 'IMPRINT.REGISTER_COURT' | translate }}</p>
                </div>

                <div class="imprint-detail">
                    <span class="label">{{ 'IMPRINT.VAT_LABEL' | translate }}</span>
                    <p>{{ 'IMPRINT.VAT' | translate }}</p>
                </div>
            </div>
        </section>

        <section class="imprint-block">
            <h2>{{ 'IMPRINT.CONTACT_TITLE' | translate }}</h2>

            <div class="imprint-text">
                <div class="contact-list">
                    <div class="contact-row">
                        <span class="label">{{ 'IMPRINT.PHONE_LABEL' | translate }}</span>
                        <a href="tel:+436504451588">{{ 'IMPRINT.PHONE' | translate }}</a>
                    </div>

                    <div class="contact-row">
                        <span class="label">{{ 'IMPRINT.EMAIL_LABEL' | translate }}</span>
                        <a href="mailto:contact@freckled.dev">{{ 'IMPRINT.EMAIL' | translate }}</a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
</div>
